import { useCallback as e } from "react";
//#region src/components/FullscreenGallery/hooks/useGalleryKeyboard.ts
var t = (t) => e((e) => {
	e.key === "ArrowLeft" ? (e.preventDefault(), t.goPrev()) : e.key === "ArrowRight" && (e.preventDefault(), t.goNext());
}, [t]);
//#endregion
export { t as useGalleryKeyboard };
